module.exports = __webpack_public_path__ + "media/27.b78270bf.mp3";